<template>
  <nav class="navbar fixed-top">
    <div class="d-flex align-items-center navbar-left">
      <a
        href="#"
        class="menu-button d-none d-md-block"
        @click.prevent.stop="
          changeSideMenuStatus({
            step: menuClickCount + 1,
            classNames: menuType,
            selectedMenuHasSubItems
          })
        "
      >
        <menu-icon />
      </a>
      <a
        href="#"
        class="menu-button-mobile d-xs-block d-sm-block d-md-none"
        @click.prevent.stop="changeSideMenuForMobile(menuType)"
      >
        <mobile-menu-icon />
      </a>
      <div class="d-inline-block">
        <b-dropdown variant="light" size="sm" class="mr-2" toggle-class="language-button">
          <template slot="button-content">
            <span class="name">{{ $i18n.locale.toUpperCase() }}</span>
          </template>
          <b-dropdown-item v-for="(l, index) in localeOptions" :key="index" @click="changeLocale(l.id)">
            {{ l.name }}
          </b-dropdown-item>
        </b-dropdown>
      </div>
      <div
        :class="{ search: true, 'mobile-view': isMobileSearch }"
        ref="searchContainer"
        @mouseenter="isSearchOver = true"
        @mouseleave="isSearchOver = false"
      >
        <b-input :placeholder="$t('anyform.search')" @keypress.native.enter="search" v-model="searchKeyword" />
        <span class="search-icon" @click="searchClick">
          <i class="simple-icon-magnifier"></i>
        </span>
      </div>
    </div>
    <router-link v-if="false" class="navbar-logo" :to="adminRoot">
      <span class="logo d-none d-xs-block"></span>
      <span class="logo-mobile d-block d-xs-none"></span>
    </router-link>

    <div class="navbar-right">
      <div class="user d-inline-block">
        <b-dropdown
          v-if="currentUser"
          class="dropdown-menu-right"
          right
          variant="empty"
          toggle-class="p-0"
          menu-class="mt-2"
          no-caret
        >
          <template slot="button-content">
            <span class="name mr-1">{{ currentUser.name }}</span>
          </template>
          <b-dropdown-item @click="logout">{{ $t('buttons.signOut') }}</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { MenuIcon, MobileMenuIcon } from '@/components/Svg'
import { menuHiddenBreakpoint, localeOptions, adminRoot } from '@/constants/config'

export default {
  components: {
    'menu-icon': MenuIcon,
    'mobile-menu-icon': MobileMenuIcon
  },
  data() {
    return {
      menuHiddenBreakpoint,
      localeOptions,
      adminRoot,
      searchKeyword: this.$route.query.search || '',
      isMobileSearch: false,
      isSearchOver: false
    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'auth/currentUser',
      menuType: 'menu/getMenuType',
      menuClickCount: 'menu/getMenuClickCount',
      selectedMenuHasSubItems: 'menu/getSelectedMenuHasSubItems'
    })
  },
  watch: {
    isMobileSearch(val) {
      if (val) {
        document.addEventListener('click', this.handleDocumentForMobileSearch)
      } else {
        document.removeEventListener('click', this.handleDocumentForMobileSearch)
      }
    }
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleDocumentForMobileSearch)
  },
  methods: {
    ...mapMutations({
      changeSideMenuStatus: 'menu/changeSideMenuStatus',
      changeSideMenuForMobile: 'menu/changeSideMenuForMobile'
    }),
    search() {
      this.$router.push({
        path: `${adminRoot}/products`,
        query: { ...this.$route.query, search: this.searchKeyword }
      })
    },
    searchClick() {
      if (window.innerWidth < this.menuHiddenBreakpoint) {
        if (!this.isMobileSearch) {
          this.isMobileSearch = true
        } else {
          this.search()
          this.isMobileSearch = false
        }
      } else {
        this.search()
      }
    },
    handleDocumentForMobileSearch() {
      if (!this.isSearchOver) {
        this.isMobileSearch = false
        this.searchKeyword = ''
      }
    },
    changeLocale(locale) {
      this.$store.dispatch('setLang', locale)
    },
    logout() {
      this.$store.dispatch('auth/signOut')
    }
  }
}
</script>
